import axiosInstance from "../../axiosInstance";

// const base = process.env.REACT_APP_API_URL || "http://localhost:3001/api";
// const BASE_URL = `${base}/contracts`;

const BASE_URL = "/crm/contracts";

// Lấy danh sách hợp đồng (có thể truyền query lọc)
export const getAllContracts = async (params = {}) => {
  const response = await axiosInstance.get(BASE_URL, { params });
  return response.data;
};

// Lấy thông tin 1 hợp đồng
export const getContractById = async (id) => {
  const response = await axiosInstance.get(`${BASE_URL}/${id}`);
  return response.data;
};

// Thêm mới hợp đồng
export const createContract = async (data) => {
  const response = await axiosInstance.post(BASE_URL, data, {
    headers: data instanceof FormData ? { "Content-Type": "multipart/form-data" } : undefined,
  });
  return response.data;
};

// Cập nhật hợp đồng
export const updateContract = async (id, data) => {
  const response = await axiosInstance.put(`${BASE_URL}/${id}`, data, {
    headers: data instanceof FormData ? { "Content-Type": "multipart/form-data" } : undefined,
  });
  return response.data;
};
  
  // Xóa hợp đồng
  export const deleteContract = async (id) => {
    const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return response.data;
  };